import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, CanActivateFn, CanMatchFn } from '@angular/router';
import { getAllowedFaqGameIdentifiers, isCasesOnlyFaqRouteForbidden } from '@dev-fast/types';

import { EnvironmentService } from '@app/core/environment-service';

import { getFaqRouteParams } from './faq-route.utils';
import { localizedUrlTree } from './localized-url-tree.util';

const isCasesOnlyMode = (environmentService: EnvironmentService): boolean => environmentService.isCasesOnly;

const getCasesOnlyEnabledGames = (environmentService: EnvironmentService): string[] =>
  getAllowedFaqGameIdentifiers(environmentService.getEnvironment().MODULES.games ?? []);

export const casesOnlyGuard: CanActivateFn = () => {
  const environmentService = inject(EnvironmentService);

  return isCasesOnlyMode(environmentService) ? localizedUrlTree('/') : true;
};

export const caseDomainOnlyGuard: CanMatchFn = () => {
  const environmentService = inject(EnvironmentService);

  return isCasesOnlyMode(environmentService) ? true : localizedUrlTree('/');
};

export const casesOnlyFaqGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const environmentService = inject(EnvironmentService);

  if (!isCasesOnlyMode(environmentService)) {
    return true;
  }

  const { position, section } = getFaqRouteParams(route);

  return isCasesOnlyFaqRouteForbidden(section, position, getCasesOnlyEnabledGames(environmentService)) ? localizedUrlTree('/faq') : true;
};
